export { default } from './VideoDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/VideoDisplay/index.js